import { DestroyRef, inject, OnChanges, SimpleChanges } from '@angular/core';
import { PassDataService } from './../../services/pass-data/pass-data.service';
import { Component, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { first, timer } from 'rxjs';

@Component({
    selector: 'urban-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit, OnChanges {
  @Input() public localized: boolean = false;
  @Input() public onContent: boolean = false;
  @Input() public disappearCondition: boolean = false;
  @Input() public borderRadius: string;

  public disappearing: boolean = false;
  public isDarkActive: boolean = true;
  
  private destroyRef: DestroyRef = inject(DestroyRef);

  constructor(
    private passDataService: PassDataService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disappearCondition && changes.disappearCondition.currentValue !== changes.disappearCondition.previousValue) {
      if (this.disappearCondition) {
        this.disappearing = true;
        timer(1000).pipe(first()).subscribe(() => {
          this.disappearing = false;
        })
      }
    }
  }

  ngOnInit(): void {
    if(this.localized) {
      this.passDataService.currentDarkModeStatus$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
        this.isDarkActive = res === true;
      });
    }
  }
}
